<template>
  <div>
    <div class="row mb-4">
      <div class="col-12 subtitle">
        Divide a tus estudiantes en grupos separados con objetivos específicos
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <button class="button secondary" @click="showModal.WorkGroup = true">
          Crear Grupo de Trabajo
        </button>
        <button class="button primary mx-3">Historial</button>
      </div>
    </div>

    <div class="row table-status custom-scroll mb-3">
      <div class="col-12 text-center mt-3 subtitle" v-if="!sessions">
        <Spinner />
      </div>
      <table
        class="table elevation-2 m-3 py-3"
        v-if="sessions && sessions.length"
      >
        <thead class="text-logo">
          <tr>
            <th></th>
            <!-- <th>Nombre</th> -->
            <th>Día a ejecutarse</th>
            <th>Horario de inicio</th>
            <th>Duración</th>
            <th>Cantidad de desafíos</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody class="text-primary">
          <tr v-for="(session, index) in sessions" :key="session.id">
            <td><div class="doc my-auto"></div></td>
            <!-- <td>Ivanna Navas</td> -->
            <td>{{ session.dateTimeExecution.split(" ")[0] }}</td>
            <td>{{ formatTime(session.dateTimeExecution) }}</td>
            <td>{{ session.duration }} min</td>
            <td>{{ session.qtyOfTests }}</td>
            <td
              class="text-brown-light pointer"
              @click="openDeleteModal(session.id, index)"
            >
              Eliminar
            </td>
            <td class="text-blue pointer" @click="editSession(session.id)">
              Editar
            </td>
          </tr>
        </tbody>
      </table>
      <div
        class="col text-center text-gray mt-3"
        v-if="sessions && sessions.length == 0"
      >
        <span> No se encontraron sesiones por listar</span>
      </div>
    </div>

    <div class="row">
      <WorkGroupModal
        v-if="showModal.WorkGroup"
        @close="
          () => {
            showModal.WorkGroup = false;
            editionData = null;
          }
        "
        @reloadSessions="reloadSessions"
        :editionData="editionData"
      />
    </div>

    <div class="row">
      <div class="col-12">
        <Modal
          @close="showModal.deleteSession = false"
          title="Eliminar Sesión"
          classes="col-md-6 col-lg-6"
          v-if="showModal.deleteSession"
        >
          <div slot="body">
            <div class="row">
              <div class="col-12 text-center">
                <button
                  class="button primary"
                  @click="
                    () => {
                      showModal.deleteSession = false;
                      selectedSession = null;
                    }
                  "
                >
                  Cancelar
                </button>
                <button class="button secondary ml-2" @click="deleteSession">
                  Eliminar
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "@/components/Modal";
import { mapState } from "vuex";
import WorkGroupModal from "@/components/workSession/WorkGroupModal";
import Spinner from "@/components/Spinner";

export default {
  name: "CreateWorkGroup",
  components: {
    WorkGroupModal,
    Modal,
    Spinner,
  },
  data() {
    return {
      showModal: {
        WorkGroup: false,
        deleteSession: false,
      },
      sessions: null,
      selectedSession: null,
      selectedSessionIndex: null,
      editionData: null,
    };
  },
  computed: {
    ...mapState(["dataUrl", "teacherData"]),
  },
  methods: {
    formatTime(date) {
      date = new Date(date);
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    async getSessions() {
      try {
        let apiUrl = `${this.dataUrl}/workSession/getWorkSessionByTeacherId?teacherId=${this.teacherData.id}`;
        let { data } = await this.axios.post(apiUrl, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
          },
        });
        this.sessions = data.content;
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          icon: "times",
          type: "danger",
        });

        // this.getSessions();
      }
    },
    openDeleteModal(id, index) {
      this.showModal.deleteSession = true;
      this.selectedSession = id;
      this.selectedSessionIndex = index;
    },
    async deleteSession() {
      let sessionId = this.selectedSession;
      let sessionIndex = this.selectedSessionIndex;
      let loader = this.$loading.show();

      try {
        let apiUrl = `${this.dataUrl}/workSession/deleteWorkSession?workSessionId=${sessionId}`;
        let { data } = await this.axios.post(apiUrl);
        if (data.status.code == 1) {
          this.showModal.deleteSession = false;
          this.sessions.splice(sessionIndex, 1);
          this.selectedSession = null;
          this.selectedSessionIndex = null;

          this.$notify({
            title: ["Eliminación exitosa"],
            type: "success",
          });
        }
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      } finally {
        loader.hide();
      }
    },
    reloadSessions() {
      this.getSessions();
    },
    async editSession(id) {
      let loader = this.$loading.show({
        container: null,
      });

      try {
        let apiUrl = `${this.dataUrl}/workSession/getWorkSessionById?workSessionId=${id}`;
        let { data } = await this.axios.post(apiUrl);

        try {
          apiUrl = `${this.dataUrl}/workSession/getAllGroupsOfAWorkSession?workSessionId=${data.content.id}`;
          let { data: groupData } = await this.axios.post(apiUrl);

          data.content.groups = groupData.content;
          this.editionData = data.content;
          this.showModal.WorkGroup = true;
        } catch {
          this.$notify({
            title: ["Ocurrió un error"],
            type: "danger",
          });
        }
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      } finally {
        loader.hide();
      }
    },
  },
  mounted() {
    this.getSessions();
  },
};
</script>
